import { render, staticRenderFns } from "./PatientFilesSection.vue?vue&type=template&id=6804b4d3&"
import script from "./PatientFilesSection.vue?vue&type=script&lang=js&"
export * from "./PatientFilesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports